import React from "react";
import DiligentModelTooltip from "./DiligentModelTooltip";
import { describeRiskScore } from "./riskScoreDisplay";

/**
 * Large stacked Risk Score card for the top-right of the VQQ Details header.
 * Visible across all tabs so the headline score is always one glance away.
 *   [RAG pill]   100.0%
 *                VQQ Risk Score
 *               [i Diligent Model]
 */
const RISK_PILL_CLASS = {
  Red: "bg-red-100 text-red-800 border-red-200",
  Yellow: "bg-yellow-100 text-yellow-800 border-yellow-200",
  Green: "bg-green-100 text-green-800 border-green-200",
};

const RiskHeaderBadge = ({ snapshot }) => {
  if (!snapshot) return null;
  // A run nobody has scored yet says so instead of painting a vacuous score.
  const display = describeRiskScore(snapshot);
  return (
    <div className="flex flex-col items-end gap-1" title={`Scoring run ${snapshot.scoring_run_id} · ${snapshot.total_rows ?? "?"} rows`}>
      <div className="flex items-center gap-3">
        {display.hasScore ? (
          <span
            className={`inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold ${RISK_PILL_CLASS[display.rag] || RISK_PILL_CLASS.Green}`}
          >
            {display.rag}
          </span>
        ) : (
          <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-100 px-3 py-1 text-sm font-semibold text-gray-600">
            Not scored
          </span>
        )}
        <span className={`${display.hasScore ? "text-3xl" : "text-2xl"} font-semibold text-gray-900 tabular-nums leading-none`}>
          {display.scoreText}
        </span>
      </div>
      <span className="text-xs text-gray-500 font-medium">VQQ Risk Score</span>
      <DiligentModelTooltip alignRight />
    </div>
  );
};

export default RiskHeaderBadge;
